import { ObjectDeleteByKey } from "utils/helpers";
import {CREATE_COLOR_SCHEME, DELETE_COLUMN, SET_COLUMN_SCHEME, LOAD_TAB_SETTINGS, CLEAR_TEMPORARY_SETTINGS } from "../constans";

const initState = {
    tabsSettings: null
};
const tabsSettingsReducer = (state = initState, { type, payload }) => {
      switch (type) {
      case LOAD_TAB_SETTINGS: {
          return {
              ...state,
              tabsSettings:{
                  ...state.tabsSettings,
                  [payload.currentTableId]: { colorScheme: payload.colorScheme, columnSchemes: payload.columnSchemes} 
              },
        }
      };
      case SET_COLUMN_SCHEME: {
        const currentTab = state.tabsSettings?.[payload.currentTableId]
        const currentTabColumnSchemes = state.tabsSettings?.[payload.currentTableId]?.columnSchemes
        if(payload.prevColumnName === payload.newColumnName) {
          return {
            tabsSettings:{
                ...state.tabsSettings,
                [payload.currentTableId]: {...currentTab, columnSchemes : {...currentTabColumnSchemes, ...payload.columnSchemes }},
            }
          };
        }
        
        const filteredScheme = ObjectDeleteByKey({
          object: currentTabColumnSchemes,
          keyToDelete: payload.prevColumnName
        })

        return {
            tabsSettings:{
                ...state.tabsSettings,
                [payload.currentTableId]: {...currentTab,columnSchemes: {...filteredScheme,...payload.columnSchemes} },
            }
        };
    }
    case DELETE_COLUMN: {
        const currentTabColumnSchemes = state?.tabsSettings[payload.currentTableId].columnSchemes
        const newColumnScheme = ObjectDeleteByKey({
          object: currentTabColumnSchemes,
          keyToDelete: payload.columnName
        })
        return {
          tabsSettings: {
            ...state.tabsSettings,
            [payload.currentTableId]: {...state.tabsSettings?.[payload.currentTableId], columnSchemes: newColumnScheme},
        },
        };
    }
    case CLEAR_TEMPORARY_SETTINGS: {
        return initState;
    }
    case CREATE_COLOR_SCHEME: {
      
      const currentTab = state?.tabsSettings?.[payload.currentTableId]
      return {
        tabsSettings: {
          ...state.tabsSettings,
          [payload.currentTableId]: {...currentTab, colorScheme: {...payload.colorScheme}},
        }
      }
    }
    default:
      return state;
  }
};
export default tabsSettingsReducer;
